import { useAuth } from '@/shared/context/AuthContext';
import {
  DEFAULT_TREATMENT_RECORDING_MODE,
  isTreatmentJournalMode,
  type TreatmentRecordingMode,
} from '@/shared/config/treatmentRecordingMode';

export const useTreatmentRecordingMode = (): TreatmentRecordingMode => {
  const { user } = useAuth();
  return isTreatmentJournalMode(user?.treatmentRecordingMode)
    ? 'treatment_journal'
    : DEFAULT_TREATMENT_RECORDING_MODE;
};

export const useTreatmentJournalMode = (): boolean =>
  useTreatmentRecordingMode() === 'treatment_journal';
